module.exports = __webpack_public_path__ + "img/spott_corrientes.2218872e.jpg";